import { render } from "./ImageBank.vue?vue&type=template&id=143add2a&scoped=true"
import script from "./ImageBank.vue?vue&type=script&lang=js"
export * from "./ImageBank.vue?vue&type=script&lang=js"

import "./ImageBank.vue?vue&type=style&index=0&id=143add2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143add2a"]])

export default __exports__